module.exports = __webpack_public_path__ + "static/media/2022__K8A0146.f92c2f85.jpg";